export default {"src":"/_next/static/media/uni.5c02a8e1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};